import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSGridModule, NSSkeletonModule } from '@norfolk-southern/accessns-components';

import { DisputeActionComponent } from '@ruby/modules/unit-train/submodules/ut-detentions/components/dispute-action/dispute-action.component';
import { DisputeStatusComponent } from '@ruby/modules/unit-train/submodules/ut-detentions/components/dispute-status/dispute-status.component';
import { UTResultsDetentionsComponent } from '@ruby/modules/unit-train/submodules/ut-detentions/components/ut-results-detentions/ut-results-detentions.component';
import { UTResultsDetentionsContainer } from '@ruby/modules/unit-train/submodules/ut-detentions/containers/ut-results-detentions/ut-results-detentions.container';
import { UTDetentionsRoutingModule } from '@ruby/modules/unit-train/submodules/ut-detentions/ut-detentions-routing.module';
import { UTFiltersFormModule } from '@ruby/modules/unit-train/submodules/ut-filters-form/ut-filters-form.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    UTResultsDetentionsContainer,
    UTResultsDetentionsComponent,
    DisputeActionComponent,
    DisputeStatusComponent
  ],
  exports: [
    UTResultsDetentionsContainer
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
    UTDetentionsRoutingModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    NSSkeletonModule,
    UTFiltersFormModule
  ]
})
export class UtDetentionsModule {}
